
<div class="m_arrow_right">
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12"><path fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-width="2" d="M1.7 1.5L6.2 6l-4.5 4.5" opacity=".2"/></svg>
</div>
